import { OrgSetupForm } from '@/features/auth';
import { setPageTitle } from '@/lib/utils';

// Access rules (signed in, no org yet) live in OrgSetupLayout.
export function OrgSetupPage() {
  setPageTitle('Organization Setup');
  return <OrgSetupForm />;
}
